import { Card, Col, Row } from "antd";

const OrderDetailsCard = ({ data, showRefundModal }) => {
  const BusinessGrid = (data) => {
    const rows = [];
    const colsPerRow = 4;
    for (let i = 0; i < data.length; i += colsPerRow) {
      const rowItems = data.slice(i, i + colsPerRow);
      const isLastRow = i + colsPerRow >= data.length;
      const colSpan = isLastRow ? 24 / rowItems.length : 6;

      rows.push(
        <Row gutter={16} key={i}>
          {rowItems.map((item, index) => (
            <Col className="gutter-row" span={colSpan} key={index}>
              <Card title={item.label} className="custom-card">
                {item.value}
              </Card>
            </Col>
          ))}
        </Row>
      );
    }

    return (
      <div className="flex flex-col items-start justify-start pt-0 min-w-screen">
        {rows}
      </div>
    );
  };

  return <>{data && BusinessGrid(data)}</>;
};
export default OrderDetailsCard;
